// GENERAL PARAMETERS

export const ENVS = {
  DEV: 'dev',
  STAGING: 'staging',
  PROD: 'production',
}

// BUSINESS PARAMETERS

export const PROXIMITY_TYPES = {
  BRANDS: 'brands',
  CATEGORIES: 'categories',
  CUSTOM_POIS: 'custom',
  LOCATIONS: 'locations',
  TAGS: 'tags',
}

export const GEO_BOUNDARIES_TYPES: {
  US: Record<string, string>
  EU: Record<string, string>
  [key: string]: string | Record<string, string> | undefined
} = {
  US: {},
  EU: {
    COUNTRY: 'Country',
    STATE: 'State',
    NUTS1: 'NUTS1',
    NUTS2: 'NUTS2',
    NUTS3: 'NUTS3',
    LAU: 'LAU',
    CITY: 'City',
    POSTAL_CODE: 'PostalCode',
    AD_REGIONS: 'AdRegion',
    FILE: 'file',
    UNITE_URBANE: 'UniteUrbane',
  },
}

export const PRODUCTS_TYPES = {
  L1_PANEL_CLASS_DIGITAL: 'l1panelclassDigital',
  L1_PANEL_CLASS_STATIC: 'l1panelclassStatic',
  L1_PANEL_CLASS: 'l1panelclass',
  L2_PRODUCT: 'l2product',
  L3_SUBPRODUCT: 'l3subproduct',
  L4: 'l4',
  L5: 'l5',
  L6: 'l6',
  L7: 'l7',
  L8: 'l8',
  L9: 'l9',
  IS_DIGITAL: 'isDigital',
}

export const AUDIENCES_TYPE = {
  INDEX: 'index',
  PERCENT: 'percent',
}

export const OPTIMIZE_BY_TYPES = {
  IMPRESSIONS: 'impressions',
  AUDIENCE: 'audience',
}

export const getRedirectUri = () => {
  return `${window.location.origin}/login`
}

export const getRequireComponent = () => {
  return import.meta.glob('./components/common/global/**/[A-Z]*.vue', {
    eager: true,
  })
}

export const SessionStorageKeys = {
  PreviousRoute: 'prvdhneiuheiu',
  DirtyPlanFilters: 'dpfiuher223giu3erwh',
  PlanUrl: 'oyj24fi987d',
}
